import { User } from 'src/store/user/types';
import { Daterange } from 'src/utils/dateHelper';
import { Participation } from './../participant/types';
import { Section } from './../sections/types';
import { Image } from './../shared/types';

export interface Station {
  id?: number;
  time: string;
  place: string;
}

export interface Bus {
  id: number;
  stations?: Station[];
  quota: number;
  hidden: boolean;
  participants?: Participation[];
  bookedBy?: number;
}

export interface CardEvent {
  id: number;
  title: string;
  shortDescription: string;
  description: string;
  quota: number | null;
  begins: Date;
  hidden: boolean;
  bikesAllowed: boolean;
  eventGroupId: number;
  sectionId: number;
  creatorId: number;
  image: Image;
  bookedBy: number;
  buses?: Bus[];
  participants?: Participation[];
  difficulty: Difficulties;
  price: number;
  familyfriendly: number;
  meetingpoint?: string;
  duration?: string;
  section?: Section;
  guides?: User[];
  eventgroup: CardEventGroup;
}

export interface CardEventGroup {
  id: number;
  dateranges: Daterange[];
  events: CardEvent[];
}

export enum Difficulties {
  easy = 0,
  medium = 1,
  hard = 2
}
export enum DifficultiesText {
  easy = 'Leicht',
  medium = 'Mittel',
  hard = 'Schwer'
}

export enum EventTypes {
  default = 0,
  bikeBus = 1,
  bus = 2
}

export enum EventTypesNames {
  default = 'Veranstaltung',
  bikeBus = 'Radbus',
  bus = 'Bus'
}

// export interface CardEvent {
//   id: number;
//   title: string;
//   shortDescription: string;
//   description: string;
//   quota: number;
//   eventgroupId: number;
//   section: Section;
//   // participants: Participation[];
//   // guides: Guide[];
//   buses: Bus[];
//   takesPlaceOn: Date;
//   hidden: boolean;
//   bikesAllowed: boolean;
//   // creator: User;

//   // eventgroup: Cardeventgroup;
//   participants: Participation[];
//   guides: Guide[];
//   image: CardImage;
// }

export interface CreateEventData {
  title: string;
  sectionTitle: string;
  section?: Section;
  shortDescription: string;
  description: string;
  quota: number | null;
  hidden: boolean;
  bikesAllowed: boolean;
  // start: Date;
  // end: Date;
  dateranges: Daterange[];
  // weekdays: number[];
  difficulty: number;
  price?: number;
  familyfriendly: number;
  guides: string[];
  buses: Bus[];
  meetingpoint?: string;
  duration?: string;
  eventgroupId?: number;
}

export const enum EventActionTypes {
  FETCH_REQUEST = '[event]FETCH_REQUEST',
  FETCH_SUCCESS = '[event]FETCH_SUCCESS',
  FETCH_ERROR = '[event]FETCH_ERROR',

  FETCH_WEEK_REQUEST = '[event]FETCH_WEEK_REQUEST',
  FETCH_ALL_SUCCESS = '[event]FETCH_ALL_SUCCESS',
  FETCH_SINGLE_SUCCESS = '[event]FETCH_SINGLE_SUCCESS',

  CREATE_REQUEST = '[event]CREATE_REQUEST',
  CREATE_SUCCESS = '[event]CREATE_SUCCESS',
  CREATE_ERROR = '[event]CREATE_ERROR',

  DELETE_EVENTS = '[event]DELETE_EVENTS',

  FETCH_DAILY_EVENTS = '[event]FETCH_DAILY_EVENTS',

  FETCH_EVENT_CARDGROUP = '[event]FETCH_EVENT_CARDGROUP',
  SET_EVENT_HIDDEN = '[event]SET_EVENT_HIDDEN',

  FETCH_SEASON_SUCCESS = '[event]FETCH_SEASON_SUCCESS',

  HIDE_EVENT = '[event]HIDE_EVENT',
  HIDE_EVENTS = '[event]HIDE_EVENTS',
  UNHIDE_EVENT = '[event]UNHIDE_EVENT'
}

export interface IEventData {
  byId: { [id: number]: CardEvent };
  allIds: number[];
  byWeekId: { [id: number]: { [day: number]: number[] } };
  nextDay: number[];
  bySeasonId: { [id: number]: number[] };
  byCardGroup: CardEvent[];
}

export interface EventState {
  readonly loading: boolean;
  readonly loadingWeek: number;
  readonly successful: boolean;
  readonly data: IEventData;
  readonly errors?: Error;
}



// WEBPACK FOOTER //
// ./src/store/events/types.ts